const RentalDifferencesSection = () => {
    return (
      <section style={{ padding: '60px 20px', backgroundColor: '#fff' }}>
        <div style={{ maxWidth: '1000px', margin: '0 auto', textAlign: 'center' }}>
          <h2 style={{ fontSize: '1.8rem', fontWeight: 'bold', color: '#1a237e', marginBottom: '12px' }}>
            Diferencias entre alquiler turístico y temporal
          </h2>
  
          <p style={{ fontSize: '1rem', color: '#666', marginBottom: '40px' }}>
            Según la normativa española, existen dos grandes categorías de alquileres de corta duración:
          </p>
  
          <div
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: '20px',
              justifyContent: 'center',
            }}
          >
            <div style={cardStyle}>
              <p style={cardTitleStyle}>Viviendas de alquiler temporal</p>
              <p style={cardDescStyle}>
                Se destinan a estancias no permanentes por motivos como trabajo, estudios o tratamientos médicos.
                No necesitan un registro autonómico adicional, ya que se rigen por la Ley de Arrendamientos Urbanos.
              </p>
            </div>
  
            <div style={cardStyle}>
              <p style={cardTitleStyle}>Viviendas de uso turístico</p>
              <p style={cardDescStyle}>
                Requieren autorización expresa y número de registro autonómico.
                Se regulan por normativa específica de cada comunidad o municipio,
                y su comercialización debe cumplir requisitos concretos.
              </p>
            </div>
          </div>
        </div>
      </section>
    );
  };
  
  const cardStyle: React.CSSProperties = {
    backgroundColor: '#fff9c4',
    borderRadius: '12px',
    padding: '24px 20px',
    flex: '1 1 400px',
    textAlign: 'left',
    boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
  };
  
  const cardTitleStyle: React.CSSProperties = {
    fontWeight: 'bold',
    fontSize: '1rem',
    marginBottom: '10px',
    color: '#000',
  };
  
  const cardDescStyle: React.CSSProperties = {
    fontSize: '0.95rem',
    color: '#444',
    lineHeight: '1.5',
  };
  
  export default RentalDifferencesSection;
  